export function processingFaq(content: TContent, parent?: TContent): TContent {
  // почему-то дважды на амп делается процессинг
  if (content.type === 'bb__faq' && content.attributes.elem) return content;

  if (content.type === 'bb__faq') {
    content.attributes = {
      elem: content.children.map((item) => processingFaq(item, content)),
    };
    content.children = [];
  } else {
    if (content.children.some((item) => item.type === 'h3')) {
      content.type = 'details';
    } else if (content.type === 'h3' && parent?.type !== 'summary') {
      content.children = [{ ...content }];
      content.type = 'summary';
    }
    content.children = content.children.map((item) => processingFaq(item, content));
  }

  return content;
}
